import { ProductShipment } from '@app/models';
import {
  ProductShipmentActionsUnion,
  ProductShipmentActionTypes
} from '@core/actions/product-shipment.actions';

import {
  ProductActionTypes,
  ProductActionsUnion
} from '@core/actions/product.actions';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<ProductShipment> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
}

export const adapter: EntityAdapter<ProductShipment> = createEntityAdapter<
  ProductShipment
>({
  selectId: (productShipment: ProductShipment) => productShipment.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ProductShipmentActionsUnion | ProductActionsUnion
) {
  switch (action.type) {
    case ProductShipmentActionTypes.LoadByFollow:
      return { ...state, loading: true, busy: true };

    case ProductShipmentActionTypes.LoadByFollowSuccess:
      return adapter.addAll(action.shipments, {
        ...state,
        loading: false,
        loaded: true,
        busy: false
      });

    case ProductShipmentActionTypes.LoadByFollowFail:
      return {
        ...state,
        loading: false
      };

    case ProductShipmentActionTypes.LoadByCountryDepartmentSuccess:
    case ProductShipmentActionTypes.BulkUpdateSuccess:
    case ProductShipmentActionTypes.LoadByProductMirrorSuccess:
      return adapter.upsertMany(action.shipments, state);

    case ProductShipmentActionTypes.BulkTransferSuccess:
      return adapter.upsertMany(action.shipments, state);

    case ProductShipmentActionTypes.BulkTransferProformaSuccess:
    case ProductShipmentActionTypes.UpsertMany:
      return adapter.upsertMany(action.productShipments, state);

    case ProductActionTypes.Clear:
    case ProductShipmentActionTypes.Clear:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('productShipments');

export const getAll = createSelector(
  getState,
  selectAll
);
export const getBusy = createSelector(
  getState,
  selectAll,
  (state: State) => state.busy
);
export const getEntities = createSelector(
  getState,
  selectEntities
);

export const getGroupedByProductCountryId = createSelector(
  getAll,
  productShipments => {
    if (productShipments) {
      const res = productShipments.reduce((obj, shipment) => {
        if (obj[shipment.ProductCountryId]) {
          obj[shipment.ProductCountryId] = [
            ...obj[shipment.ProductCountryId],
            shipment
          ];
        } else {
          obj[shipment.ProductCountryId] = [shipment];
        }

        return obj;
      }, {});
      return res;
    }
  }
);
